export const BUILD_VERSION = '1777559715';
